require("!!/node_modules/script-loader/addScript.js")(require("!!/node_modules/raw-loader/index.js!/core/client/vendor/modernizr.js"))


/** WEBPACK FOOTER **
 ** core/client/vendor/modernizr.js
 **/